import React, { useRef, useState } from "react";
import _ from "lodash";
import ConfirmDialog from "../Modal/ConfirmDialog";
import { longPressTime } from "../../config/constants";
import parse from "html-react-parser";
import RichTextInput from "./RichTextInput";
import { dateProcess, timeStamp } from "../../js/modules/Generic";
import PropTypes from "prop-types";
import {
  PlusIcon,
  CalenderIcon,
  AdminIcon,
  DeleteButtonIcon,
} from "./Icons/SvgIcon";

const AuditNotes = ({ notes, updateNotes }) => {
  const richTextInputRef = useRef(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [noteKeyToDelete, setNoteKeyToDelete] = useState(null);

  const saveText = (event, theText, theIdentifier, theCallback) => {
    if (event) {
      event.preventDefault();
    }

    let tmpNotes = [...notes];
    let newNote;
    let tmpEdits;

    if (theIdentifier !== undefined) {
      tmpEdits = [...notes[theIdentifier].edits];
      tmpEdits.unshift({ standardDate: timeStamp() });

      newNote = {
        content: theText,
        edits: tmpEdits,
      };

      tmpNotes[theIdentifier] = newNote;
    } else {
      newNote = {
        content: theText,
        edits: [
          {
            standardDate: timeStamp(),
          },
        ],
      };

      tmpNotes.push(newNote);
    }

    tmpNotes = _.orderBy(tmpNotes, "edits[0].standardDate", "desc");
    updateNotes(tmpNotes, theCallback);
  };

  const editNote = (event, key) => {
    if (event) {
      event.preventDefault();
    }
    richTextInputRef.current.goRichText(event, key, notes[key].content);
  };

  const deleteNote = (event, key) => {
    if (event) {
      event.preventDefault();
    }
    setNoteKeyToDelete(key);
    setShowDeleteConfirm(true);
  };

  const handleConfirmDeleteNote = () => {
    setShowDeleteConfirm(false);
    if (noteKeyToDelete !== null) {
      let tmpNotes = [...notes];
      tmpNotes.splice(noteKeyToDelete, 1);
      updateNotes(tmpNotes);
      setNoteKeyToDelete(null);
    }
  };

  const handleCancelDeleteNote = () => {
    setShowDeleteConfirm(false);
    setNoteKeyToDelete(null);
  };

  const renderNotes = (key) => {
    const deleteNoteStart = (event) => {
      if (event) {
        event.preventDefault();
      }
      window.deleteNoteTimer = setTimeout(
        () => deleteNote(false, key),
        longPressTime,
      );
    };

    const deleteNoteCancel = (event) => {
      if (event) {
        event.preventDefault();
      }
      clearTimeout(window.deleteNoteTimer);
    };

    const note = notes[key];

    return (
      <li className="note-list-item">
        <div className="d-flex align-items-center justify-content-between g-16">
          <div className="d-flex align-items-center g-12">
            <div className="d-flex align-items-center g-4">
              <CalenderIcon />
              <span className="text-xs text-gray-600">
                {dateProcess(note.edits[0].standardDate, "printForAuditNote")}
              </span>
            </div>
            <div className="d-flex align-items-center g-4">
              <AdminIcon />
              <span className="text-xs text-gray-600">Admin</span>
            </div>
          </div>
          <button className="delete-icon">
            <DeleteButtonIcon />
          </button>
        </div>
        <p className="mt-8">{parse(note?.content)}</p>
      </li>
    );
  };

  return (
    <div className="notes-card card mb-24">
      <div className="card-header mb-0">
        <div>
          <h4 className="title">Notes</h4>
          <p className="text-sm text-gray-600">Admin notes for this client</p>
        </div>
        <button
          className="btn-warning icon-with-btn"
          onClick={(e) => richTextInputRef.current.goRichText(e)}
        >
          <PlusIcon /> Add note
        </button>
      </div>
      <ul className="note-list">
        {notes && _.size(notes) > 0
          ? Object.keys(notes).map(renderNotes)
          : null}
      </ul>

      <RichTextInput ref={richTextInputRef} saveText={saveText} />

      <ConfirmDialog
        open={showDeleteConfirm}
        title="Delete Note"
        message="Are you sure you want to delete this note?"
        onConfirm={handleConfirmDeleteNote}
        onCancel={handleCancelDeleteNote}
        confirmText="Delete"
        cancelText="Cancel"
        variant="danger"
      />
    </div>
  );
};

AuditNotes.propTypes = {
  updateNotes: PropTypes.func.isRequired,
  notes: PropTypes.array.isRequired,
};

export default AuditNotes;
